var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.069 20.7633C24.069 22.3731 21.8033 23.3302 17.272 25.2444C15.4516 26.0133 14.5414 26.3978 13.5887 26.3978C12.6359 26.3978 11.7257 26.0133 9.90537 25.2444C5.37405 23.3302 3.1084 22.3731 3.1084 20.7633L3.1084 8.93066L13.5887 14.0018L24.069 8.93066L24.069 20.7633Z",
    fill: "url(#paint0_linear_4930_7615)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82046 14.3628C6.03617 13.9314 6.56077 13.7565 6.99219 13.9722L9.32115 15.1367C9.75257 15.3524 9.92743 15.877 9.71172 16.3084C9.49601 16.7399 8.97141 16.9147 8.53999 16.699L6.21104 15.5345C5.77962 15.3188 5.60475 14.7942 5.82046 14.3628Z",
    fill: "url(#paint1_linear_4930_7615)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4616 14.3786C15.4924 14.185 16.5634 13.6663 18.0538 12.9446L21.7118 11.1745C22.2672 10.9058 22.7696 10.6627 23.1952 10.4317L23.1952 13.5887C23.1952 14.0711 23.5862 14.4621 24.0686 14.4621C24.5509 14.4621 24.9419 14.071 24.9419 13.5887L24.9419 8.9308C24.9419 8.84653 24.93 8.76505 24.9077 8.68796C24.9299 8.5809 24.9419 8.46791 24.9419 8.34856C24.9419 7.53104 24.3773 7.0114 23.8574 6.66023C23.3381 6.30951 22.5914 5.94822 21.7119 5.52267L18.0538 3.75253C16.142 2.82674 14.9202 2.23506 13.5883 2.23506C12.2564 2.23506 11.0346 2.82674 9.12278 3.75254L5.46476 5.52266C4.58518 5.94822 3.83844 6.30951 3.3192 6.66023C2.79932 7.0114 2.23464 7.53104 2.23464 8.34856C2.23464 8.4679 2.24667 8.5809 2.26884 8.68796C2.24657 8.76505 2.23463 8.84653 2.23463 8.9308L2.23464 20.7634C2.23464 22.0681 3.18641 22.9358 4.35786 23.6387C5.54375 24.3503 7.2883 25.0872 9.49276 26.0185L9.73868 26.1224C11.3911 26.821 12.4564 27.2713 13.5883 27.2713C14.58 27.2713 15.3863 26.9237 16.5754 26.4109L16.844 26.2953C17.2873 26.105 17.4923 25.5914 17.302 25.1482C17.1117 24.705 16.5974 24.5002 16.1542 24.6905C15.3583 25.0322 14.8549 25.2484 14.4616 25.3748L14.4616 14.3786ZM3.98135 10.4317C4.40698 10.6627 4.90939 10.9058 5.46477 11.1745L9.12278 12.9446C10.6131 13.6663 11.6842 14.185 12.7149 14.3786L12.7149 25.3943C12.1573 25.2409 11.4317 24.9413 10.2448 24.44C7.95217 23.4715 6.32343 22.7811 5.25661 22.141C4.1624 21.4844 3.98135 21.0686 3.98135 20.7634L3.98135 10.4317ZM9.69032 5.41842C11.8654 4.36593 12.7061 3.98177 13.5883 3.98177C14.4705 3.98177 15.3112 4.36594 17.4863 5.41842L17.4913 5.42088L7.70096 10.3161L6.28864 9.63266C5.32876 9.16819 4.69871 8.86084 4.2969 8.58943C4.1241 8.47272 4.04062 8.39363 4.00198 8.34856C4.04062 8.30349 4.1241 8.22441 4.2969 8.10769C4.69871 7.83628 5.32876 7.52893 6.28864 7.06446L9.69032 5.41842ZM9.68582 11.2765L9.69032 11.2787C11.8654 12.3312 12.7061 12.7154 13.5883 12.7154C14.4705 12.7154 15.3112 12.3312 17.4863 11.2787L20.8879 9.63267C21.8478 9.16819 22.4779 8.86084 22.8797 8.58944C23.0525 8.47272 23.136 8.39362 23.1746 8.34856C23.136 8.30349 23.0525 8.2244 22.8797 8.10769C22.4779 7.83628 21.8478 7.52893 20.8879 7.06445L19.4762 6.38133L9.68582 11.2765Z",
    fill: "url(#paint2_linear_4930_7615)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3219 16.2088C22.8042 16.2088 23.1952 16.5998 23.1952 17.0821L23.1952 20.2845L26.3975 20.2845C26.8799 20.2845 27.2709 20.6755 27.2709 21.1578C27.2709 21.6402 26.8799 22.0312 26.3975 22.0312L23.1952 22.0312L23.1952 25.2335C23.1952 25.7158 22.8042 26.1068 22.3219 26.1068C21.8395 26.1068 21.4485 25.7158 21.4485 25.2335L21.4485 22.0312L18.2462 22.0312C17.7639 22.0312 17.3728 21.6402 17.3728 21.1578C17.3728 20.6755 17.7639 20.2845 18.2462 20.2845L21.4485 20.2845L21.4485 17.0821C21.4485 16.5998 21.8395 16.2088 22.3219 16.2088Z",
    fill: "url(#paint3_linear_4930_7615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4930_7615",
    x1: 13.5887,
    y1: 8.93066,
    x2: 13.5887,
    y2: 26.3978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4930_7615",
    x1: 14.9124,
    y1: 27.239,
    x2: 14.275,
    y2: 2.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4930_7615",
    x1: 14.9124,
    y1: 27.239,
    x2: 14.275,
    y2: 2.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4930_7615",
    x1: 14.9124,
    y1: 27.239,
    x2: 14.275,
    y2: 2.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageAdd);
export default __webpack_public_path__ + "static/media/package-add.fb9dfa35e0c1536bc602da2b43a1a5f3.svg";
export { ForwardRef as ReactComponent };